import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateConsul } from "../redux/actions/honararyConsulAction";
import moment from "moment";
import { CONSUL_UPDATE_RESET } from "../redux/constants/honararyConsulConstant";
import axios from "axios";
import { baseUrl, url } from "../utils/env";

const EditHonororyConsulScreen = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const consulEdit = useSelector((state) => state.consulEdit);
  const { adminInfo } = useSelector((state) => state.adminLogin);
  const { success } = consulEdit;
  const listConsul = useSelector((state) => state.listConsul);
  const { consul } = listConsul;
  const [name, setName] = useState("");
  const [joinDate, setJoinDate] = useState("");
  const [image, setImage] = useState("");
  const [description, setDescription] = useState("");
  const [uploading, setUploading] = useState(false);
  const [previewSource, setPreviewSource] = useState();
  const [previewOldSource, setPreviewOldSource] = useState();

  const handleCkEditorChange = (e, editor) => {
    setDescription(editor.getData());
  };
  const handleSubmitForm = (e) => {
    e.preventDefault();
    dispatch(updateConsul(name, joinDate, image, description, uuid));
  };

  useEffect(() => {
    if (success) {
      navigate("/honorary-consul");
      dispatch({ type: CONSUL_UPDATE_RESET });
    }
  }, [success]);

  const previewFile = (file) => {
    console.log(file);
    const reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
    }
    reader.onloadend = () => {
      setPreviewSource(reader.result);
    };
  };

  const uploadFileHandler = async (e) => {
    const file = e.target.files[0];
    previewFile(file);
    const formData = new FormData();
    formData.append("image", file);
    setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };

      const { data } = await axios.post(`${baseUrl}/upload`, formData, config);

      setImage(data[0].path);
      setUploading(false);
    } catch (err) {
      console.error(err);
      setUploading(false);
    }
  };
  return (
    <Layout>
      <PageTitle title="Add New Honorory Consul" />
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmitForm}>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                Full Name
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Name Of Hpnorory Consul"
                  onChange={(e) => setName(e.target.value)}
                  defaultValue={consul && consul.name}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label
                htmlFor="example-week-input"
                className="col-sm-2 col-form-label"
              >
                Join Date
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="date"
                  id="example-week-input"
                  onChange={(e) => setJoinDate(e.target.value)}
                  value={moment(consul && consul.joinDate).format("YYYY-MM-DD")}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label
                htmlFor="example-search-input"
                className="col-sm-2 col-form-label"
              >
                Choose Image
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="file"
                  onChange={uploadFileHandler}
                />
                {previewSource && (
                  <div className="previewImage">
                    <img src={previewSource} alt="profile" />
                  </div>
                )}
                {consul && consul.image && (
                  <div className="previewImage">
                    <img
                      src={`${url}${consul && consul.image}`}
                      alt="profile"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                Description
              </label>
            </div>
            <div className="col-12 mb-3">
              <CKEditor
                editor={ClassicEditor}
                class="form-control"
                placeholder="Description of Job"
                onChange={(e, editor) => {
                  handleCkEditorChange(e, editor);
                }}
                data={consul && consul.description}
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Edit New Honorary Consul
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default EditHonororyConsulScreen;
